<template>
    <div class="vuetify-wrapper">
        <v-btn
            @click.stop="toggleDialog"
            :loading="loading"
            min-width="30"
            class="price-suggestion-btn"
            small
            outlined
            text
        >
            <v-icon small color="black">mdi-currency-eur</v-icon>
        </v-btn>
        <v-dialog
            content-class="vuetify-wrapper"
            v-model="dialog"
        >
            <v-card>
                <v-card-title class="text-h5">
                    Preisvorschlag
                </v-card-title>
                <v-card-text v-if="pricingSuggestions">
                    <table class="table">
                        <thead>
                            <th>Service</th>
                            <th>Apo</th>
                            <th>FB</th>
                            <th>FPP</th>
                            <th>Erklärung</th>
                        </thead>
                        <tbody>
                            <tr v-for="( pricing, service ) in pricingSuggestions" :class="service">
                                <td>{{ $t(service) }}</td>
                                <td class="apo">{{ pricing.pharmacy }}€</td>
                                <td class="fb">{{ pricing.pharmacist }}€</td>
                                <td class="fpp">{{ +pricing.pharmacy - +pricing.pharmacist }}€</td>
                                <td>{{ pricing.explanation }}</td>
                            </tr>
                        </tbody>
                    </table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    name: 'PriceSuggestion',
    components: { },
    props: {
        pricingSuggestions: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            dialog: false,
        };
    },
    methods: {
        async toggleDialog() {
            this.dialog = !this.dialog;
        },
    },
};
</script>

<style scoped>
.bootstrap-button {
    /** Make it look the same as the bootstrap buttons */
    border-radius: 3px;
    border-color: #ccc;
    width: 34px !important;
    height: 30px !important;
    color: #333 !important;
}
.black--text {
    color: black;
}
</style>
